import { Line } from 'react-chartjs-2'
import { Chart, registerables } from "chart.js"
import { User } from 'model/User'
import { Game, getUser } from 'model/Game'
import { getString } from 'script/dateutil'

Chart.register(...registerables)


type Props = {
  user: User
  games: Game[]
}
export default function RateTransition(props: Props) {

  const games = props.games
    .slice()
    .sort((a, b) => a.start_time - b.start_time)

  function getGameDates(): string[] {
    if (!games) return []
    if (!games.length) return []
    const dates = games.map(game => getString(new Date(game.start_time)).slice(5, -3))
    dates.unshift(
      getString(new Date(games[0].season.start_time)).slice(5, -3)
    )
    return dates
  }

  function getRates(): number[] {
    const rates = games.map(game => {
      const user = getUser(props.user, game)
      return user.rate + (user.rate_diff ?? 0)
    })
    rates.unshift(1500)
    return rates
  }

  function getMinRate(): number {
    const minRate = Math.min(...getRates())
    return Number((minRate.toString().slice(0, 2) + '00'))
  }

  function getMaxRate(): number {
    let maxRate = Math.max(...getRates()) + 100
    if (maxRate % 100) return Number((maxRate.toString().slice(0, 2) + '00'))
    return maxRate
  }


  const options = {
    scales: {
      yAxis: {
        min: getMinRate(),
        max: getMaxRate(),
      }
    },
    plugins: {
      datalabels: {
        display: false
      },
      legend: {
        display: false
      }
    }
  }
  const labels = getGameDates()

  const data = {
    labels,
    datasets: [
      {
        data: getRates(),
        borderColor: 'rgb(255, 99, 132)',
      },
    ],
  }

  return (
    <Line options={options} data={data} />
  )
}